import { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
export const RenderInWindow = (props) => {
    const [container, setContainer] = useState(null);
    const newWindow = useRef(null);
    useEffect(() => {
        const div = document.createElement('div');
        setContainer(div);
    }, []);
    useEffect(() => {
        var _a;
        // When container is ready
        if (container) {
            // Create window
            newWindow.current = window.open(props.url, '_blank', 'width=900,height=600,left=200,top=200');
            // Append container
            (_a = newWindow.current) === null || _a === void 0 ? void 0 : _a.document.body.appendChild(container);
            // Save reference to window for cleanup
            const curWindow = newWindow.current;
            // Return cleanup function
            return () => {
                curWindow === null || curWindow === void 0 ? void 0 : curWindow.close();
                newWindow.current = null;
            };
        }
    }, [container, props.url]);
    return container && createPortal(props.children, container);
};
